import gql from 'graphql-tag';
import UserBillingAddressFragment from './UserBillingAddressFragment';
import UserShippingAddressFragment from './UserShippingAddressFragment';

export default gql`
fragment UserDetailsFragment on User {
    id
    ext_id
    last_login
    email
    name
    telephone
    default_billing_address {
        ...UserBillingAddressFragment
    }
    default_shipping_address {
        ...UserShippingAddressFragment
    }
    shipping_addresses {
        ...UserShippingAddressFragment
    }
    billing_addresses {
        ...UserBillingAddressFragment
    }
    saved_credit_cards {
        id
        card_title
        card_type
        card_pan
        card_exp
        is_default
    }
    product_discounts {
        id
        discount
        user_id
        is_active
        active_from
        active_to
        created_at
        updated_at
    }
    shipping_discounts {
        id
        discount
        user_id
        is_active
        active_from
        active_to
        created_at
        updated_at
    }
    created_at
    lyoness_card_number
    is_admin
    ip_address
    orders_count
    orders_value_sum
    first_order_date
    last_order_date
}
${UserBillingAddressFragment}
${UserShippingAddressFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/UserDetailsFragment.ts